import { Component, Input } from "@angular/core";

import { ShadeFinderModalService } from "../services/shade-finder-modal.service";

@Component({
    selector: "h-shade-finder-button",
    templateUrl: "./shade-finder-button.component.html",
    styleUrls: ["./shade-finder-button.component.scss"],
})
export class ShadeFinderButtonComponent {
    @Input()
    public hasTransition: boolean = false;

    constructor(private shadeFinderModalService: ShadeFinderModalService) {}

    public async openModal(): Promise<void> {
        await this.shadeFinderModalService.openShadeFinderModal();
    }
}
